<div class="object-copy-field">
  <mat-checkbox
    [checked]="isFieldSelected()"
    [disabled]="isFieldRequired()"
    (change)="objectCopyService.toggleField($event.checked, field())"
  >
    <app-display-field-title
      [field]="viewField()"
      class="object-copy-field__title"
    />
  </mat-checkbox>

  <div class="object-copy-field__value">
    @for (item of viewField().items; track $index) {
      @if ($index < 10 || viewField().$$showAll) {
        <div
          class="object-copy-field__value-content"
          [ngClass]="{
            'object-copy-field__value-content--level-1': item.header_values && item.header_values.level === 1,
            'object-copy-field__value-content--level-2': item.header_values && item.header_values.level === 2,
          }"
        >
          @if (item.header_values) {
            <div
              class="item-header"
              [ngClass]="{'bold': item.header_values.level === 1}"
            >
              <app-object-view-field-values
                [fieldValues]="item.header_values"
                [sectionsContainer]="sectionsContainer()"
              />
            </div>
          }

          @if (item.field_values) {
            <app-object-view-field-values
              [fieldValues]="item.field_values"
              [sectionsContainer]="sectionsContainer()"
            />
          }
        </div>
      }
    }

    <app-object-view-show-more [field]="viewField()" />
  </div>
</div>
